exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Button__button___2a549 {\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  outline: none;\n  border: 0;\n}\n\n.Button__primary___1gH9y {\n  background-color: #1774f0;\n}\n\n.Button__primary___1gH9y:hover {\n  background-color: #0234e1;\n}\n\n.Button__secondary___22F7i {\n  background-color: #03d8a9;\n}\n\n.Button__secondary___22F7i:hover {\n  background-color: #00b670;\n}\n\n.Button__round___12Akf {\n  margin: 10px;\n  height: 30px;\n  border: none;\n  border-radius: 100px;\n  line-height: 2.2;\n  padding: 0 15px 0 15px;\n}\n\n.Button__square___3PO4o {\n  padding: 12px 29px;\n  height: 14px;\n  border: none;\n  border-radius: 5px;\n}\n\n.Button__condensed___3Inc9 {\n  padding: 7px 29px;\n  height: 30px;\n  border: none;\n  border-radius: 5px;\n}\n\n.Button__formButton___2hUMf {\n  padding: 12px 13px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n", ""]);

// exports
exports.locals = {
	"button": "Button__button___2a549",
	"primary": "Button__primary___1gH9y",
	"secondary": "Button__secondary___22F7i",
	"round": "Button__round___12Akf",
	"square": "Button__square___3PO4o",
	"condensed": "Button__condensed___3Inc9",
	"formButton": "Button__formButton___2hUMf"
};